import { render } from "./UpdateStoreAccountActivation.vue?vue&type=template&id=678a2605"
import script from "./UpdateStoreAccountActivation.vue?vue&type=script&lang=js"
export * from "./UpdateStoreAccountActivation.vue?vue&type=script&lang=js"

import "./UpdateStoreAccountActivation.vue?vue&type=style&index=0&id=678a2605&lang=css"

import exportComponent from "/app/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__